<template>
  <div class="container">
    <div v-show="data.report.departments.length > 0">
      <div v-show="data.report.departments.length == 0" class="text-center">No Data</div>
      <table
        class="table table-condensed table-striped standard-report"
        v-show="data.report.departments.length > 0"
      >
        <thead>
          <tr class="table-header header text-left">
            <th>
              <span class>Category</span>
            </th>
            <th class="text-center">
              <span class>Qty</span>
            </th>
            <th class="text-right">
              <span class>$</span>
            </th>
            <th class="text-right">
              <span class>%</span>
            </th>
          </tr>
        </thead>
        <tbody
          v-show="data.report.departments.length > 0"
          v-for="d in data.report.departments"
          :key="d.id"
        >
          <tr class="border-right">
            <td colspan="4">
              <strong>{{ d.catgroup }}</strong>
            </td>
          </tr>
          <tr class="border-right" v-for="c in d.items" :key="c.id">
            <td class="text-left">{{ c.categoryDESC }}</td>
            <td class="text-right">{{ c.quantity }}</td>
            <td class="text-right">{{ c.sales | currency }}</td>
            <td class="text-right">{{ c.pct }}%</td>
          </tr>
          <tr class="border-right">
            <td class="label-total">{{ d.catgroup }} Total</td>
            <td class="text-right">{{ d.quantity }}</td>
            <td class="text-right">{{ d.sales | currency }}</td>
            <td class="text-right">{{ d.pct }}%</td>
          </tr>
        </tbody>
        <tbody v-show="!data.report.departments.length > 0">
          <tr class="border-right">
            <td colspan="4" class="text-center">NO DATA AVAILABLE</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="border-right">
            <td class="label-total">
              <strong>Total:</strong>
            </td>
            <td
              class="cell-running-total text-right"
              style="color:green; text-align: center;"
            >{{ data.report.quantity }}</td>
            <td class="cell-running-total text-right">{{ data.report.total | currency }}</td>
            <td class="cell-running-total text-right">{{ data.report.pct }}%</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import UserService from '@/services/UserService'
import DailyJournalReportService from '@/services/DailyJournalReportService'
import DailyReportTab from './dailyReportTab'

export default {
  extends: DailyReportTab,
  components: {
  },
  data () {
    return {
      data: {
        loading: true,
        report: {
          departments: []
        }
      },
      loadTimeout: null
    }
  },
  computed: {
    grossView: function () {
      return UserService.getConfigOption('gross_sales_view').value === 'yes'
    },
    checkGuestStats: function () {
      return UserService.getConfigOption('avg_check_guest_stats').value === 'yes'
    }
  },
  methods: {
    loadData: function () {
      if (this.isActive > 0 && this.loadTimeout === null) {
        this.loadTimeout = setTimeout(() => {
          this.$updateloading(1)
          this.data.loading = true
          DailyJournalReportService.getCategoriesSummary(this.locationId, this.dailyDate, (this.grossView ? 'gross' : 'net'))
            .then(res => {
              this.$updateloading(-1)
              this.data.loading = false
              this.data.report = res
              this.loadTimeout = null
            })
        }, 100)
      }
    }
  }
}
</script>
